import loadApplab from './init/loadApplab';
import loadAppOptions from '@cdo/apps/code-studio/initApp/loadApp';

loadAppOptions().then(loadApplab);
